<template>
  <div class>
    <div class="row">
      <div class="col-12">
        <CommunityCard>
          <template #header>
            <div class="isim-community-card-header">
              <img src="../assets/star-outline.svg" alt="star" />
              <h5>Favourite Scenarios</h5>
            </div>
          </template>

          <p
            class="text-center info-text"
            v-show="favouriteScenarios.length == 0 && !isLoading"
          >
            Use the <img src="../assets/star-outline.svg" alt="star" /> to
            favourite some scenarios!
          </p>
          <ul class="favourite-scenarios list-group">
            <li
              v-bind:key="scenario.uuid_id"
              class="isim-favourites-list-item"
              v-for="scenario in favouriteScenarios"
            >
              <FavouriteScenario :scenario="scenario"></FavouriteScenario>
            </li>
          </ul>
        </CommunityCard>
      </div>
    </div>
  </div>
</template>

<script>
import FavouriteScenario from "../components/FavouriteScenario";
import CommunityCard from "../components/CommunityCard";
import { mapState } from "vuex";

export default {
  name: "FavouriteScenariosList",
  computed: {
    ...mapState("favouritesStore", {
      favouriteScenarios: (state) => state.favouriteScenarios,
    }),
  },
  user() {
    return this.$store.getters.getUser;
  },
  data() {
    return {
      isLoading: false,
    };
  },
  components: {
    FavouriteScenario,
    CommunityCard,
  },
};
</script>

<style>
.isim-community-card-header {
  display: flex;
  margin: 1rem;
  align-items: center;
}

.isim-community-card-header > h5 {
  color: var(--isim-primary);
  margin: 0 0 0 1rem;
  font-weight: bold;
  font-size: 16px;
}

.isim-favourites-list-item {
  padding: 0.75rem;
  list-style: none;
}
.isim-favourites-list-item:nth-child(odd) {
  background-color: #f8f9fa;
}
.favourite-scenarios .isim-favourites-list-item.active {
  border: 2px solid #ff9817;
}

.favourite-scenarios li:last-child {
  border-bottom-left-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
}

.favourite-icon {
  font-size: 20px;
  color: var(--isim-light-text);
}
</style>
